module.exports = __webpack_public_path__ + "img/express.df3a4848.png";